import { render, staticRenderFns } from "./isvnew.vue?vue&type=template&id=7b8dc49b"
import script from "./isvnew.vue?vue&type=script&lang=js"
export * from "./isvnew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports